/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var DataPageTypeCalculatedStatus;
(function (DataPageTypeCalculatedStatus) {
    DataPageTypeCalculatedStatus["NOT_CALCULATED"] = "NOT_CALCULATED";
    DataPageTypeCalculatedStatus["NO_PAGE_TYPE_FOUND"] = "NO_PAGE_TYPE_FOUND";
    DataPageTypeCalculatedStatus["PAGE_TYPE_CALCUATED"] = "PAGE_TYPE_CALCUATED";
})(DataPageTypeCalculatedStatus || (DataPageTypeCalculatedStatus = {}));
export function DataPageTypeCalculatedStatusFromJSON(json) {
    return DataPageTypeCalculatedStatusFromJSONTyped(json, false);
}
export function DataPageTypeCalculatedStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function DataPageTypeCalculatedStatusToJSON(value) {
    return value;
}
